import { remoteProgrammingReducer } from './quickstart-remotes.service';

export const QUICKSTART_REMOTES_REDUCERS: any = {
  remoteProgramming: remoteProgrammingReducer
};



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-system-remotes/quickstart-remotes.stores.ts